import { Link } from "react-router-dom";
const aadyaHighlights = [
  {
    title: "Zwei ruhige G\xE4rten, die zur Meditation einladen",
    image: "/images/Finalized photos/Edited/DSC01259.webp",
    paragraphs: [
      "Das Resort verf\xFCgt \xFCber zwei unterschiedliche G\xE4rten. Im Frontgarden mit Blick auf die Bucht k\xF6nnen Sie im Schatten der Palmen lesen oder einfach nur das Meer betrachten. Das rhythmische Rauschen der Wellen f\xFChrt Sie ganz nat\xFCrlich in eine tiefe Meditation. Auch von der gro\xDFz\xFCgigen Lobby aus bietet sich ein wundersch\xF6ner Ausblick auf das Meer zwischen den B\xE4umen.",
      "Der Hintergarten hingegen ist ein mystischer Ort, gesch\xFCtzt von riesigen, steil aufragenden Felsw\xE4nden. Im Yoga-Pavillon im Einklang mit dem Garten verbringen Sie ruhige Momente, in denen K\xF6rper, Geist und Seele wieder zur Ruhe kommen."
    ]
  },
  {
    title: "Elegante Zimmer mit Meerblick in jedem Raum",
    image: "/images/Hiru/public_images/680A2401-Enhanced-NR-2-Edit-copy.webp",
    paragraphs: [
      "In Hiru Aadya gibt es 11 Zimmer, und alle verf\xFCgen \xFCber einen Balkon oder eine Terrasse mit Meerblick. Die gro\xDFz\xFCgigen Innenr\xE4ume von etwa 38 m\xB2 sind mit stilvoller Einrichtung und modernen M\xF6beln gestaltet und schaffen eine angenehme Atmosph\xE4re."
    ],
    features: [
      "Zimmerausstattung: Deckenventilator, Klimaanlage und Moskitonetz inklusive.",
      "Sicherheits- und Komfortfeatures: Dusche und WC, F\xF6hn, Safe, Telefon und kostenloses WLAN.",
      "1. Etage (Erdgeschoss): 4 Zimmer / 2. Etage (1. Obergeschoss): 7 Zimmer."
    ]
  },
  {
    title: "Ayurveda-Erlebnisse in Harmonie mit der Natur",
    image: "/images/Finalized photos/Edited/DSC01568.webp",
    paragraphs: [
      "Im Ayurveda-Garten hinter dem Hauptgeb\xE4ude befindet sich das Ayurveda-Zentrum mit 7 Therapier\xE4umen. Nach dem bew\xE4hrten Hiru-Konzept betreuen erfahrene \xC4rzte und Therapeuten Sie t\xE4glich mit fachlicher Expertise.",
      "Bei gutem Wetter k\xF6nnen Sie im Schatten der Palmenkopf-, Gesichts-, Hand- und Fu\xDFmassagen genie\xDFen. Auch traditionelle Blumenb\xE4der, die in der Natur stattfinden, f\xF6rdern tiefe Entspannung."
    ],
    links: [
      { label: "Mehr \xFCber Wellnessbehandlungen", href: "/ayurveda/panchakarma" },
      { label: "Ayurveda-Panchakarma", href: "/ayurveda/panchakarma" }
    ]
  },
  {
    title: "Ayurvedische K\xFCche mit Meerblick",
    image: "/images/Finalized photos/Edited/DSC01249.webp",
    paragraphs: [
      "Im neu er\xF6ffneten Restaurant mit Meerblick genie\xDFen Sie Ihre Mahlzeiten bei dem Klang der Wellen. Sie k\xF6nnen allein in Ruhe essen oder, falls gew\xFCnscht, mit anderen G\xE4sten am Tisch gemeinsam essen und sich austauschen.",
      "Serviert wird Ihnen eine 3-G\xE4nge-Auswahl, die speziell auf Ihre Dosha-Typologie und Ihr Behandlungsprogramm abgestimmt ist. So erleben Sie eine Zeit, in der innere Vitalit\xE4t und Gesundheit von innen heraus gest\xE4rkt werden."
    ],
    links: [{ label: "Mehr \xFCber die ayurvedische K\xFCche erfahren", href: "/ayurveda/food" }]
  },
  {
    title: "Ausfl\xFCge in die Natur Ahungallas",
    image: "/images/Finalized photos/Edited/DSC01770.webp",
    paragraphs: [
      "Zwischen den intensiven Behandlungen k\xF6nnen Sie auch die Natur rund um das Resort genie\xDFen und Sri Lanka etwas n\xE4her kennenlernen. Besuchen Sie zum Beispiel die nahegelegene Schildkr\xF6ten-Schutzstation, um die Bedeutung des Lebens direkt zu erleben.",
      "Eine Sunrise-Bootstour auf dem Madhu-Fluss bietet einen magischen Morgen mit wildlebenden V\xF6geln und tropischen Reptilien. Kleine Ausfl\xFCge planen wir gern gemeinsam mit Ihnen."
    ]
  }
];
const AboutAadya = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Hiru Aadya / Ahungalla
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Hiru Aadya Ayurveda Resort in Ahungalla
                    </h2>
                    <div className="mx-auto mt-8 flex h-28 w-64 items-center justify-center sm:h-36 sm:w-80">
                        <img
    src="/images/Logos/hiru_adya.webp"
    alt="Logo des Ayurveda-Resorts Hiru Aadya"
    width={320}
    height={144}
    className="h-full w-full object-contain" loading="lazy" />
                    </div>
                    <h3 className="mt-8 font-serif text-2xl font-semibold leading-tight text-[#1f4d3c] sm:text-3xl">
                        Ein ruhiger Rückzugsort, geschützt von tiefer Stille und Natur
                    </h3>
                    <div className="mx-auto mt-7 max-w-3xl space-y-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            Im Oktober 2025 entstand Hiru Aadya als fünftes „Zuhause“ der Hiru-Gruppe an der schönen Küste von Ahungalla. Das bisherige Beach-Resort wurde komplett renoviert und zu einem echten Ayurveda-Heiligtum mit viel Liebe zum Detail umgebaut. Es liegt etwa 120 km vom Flughafen entfernt und ist mit dem Auto in knapp 2 Stunden erreichbar.
                        </p>
                        <p>
                            Das Resort liegt an einer ruhigen Bucht am Rand des Golden Mile Beach und verfügt über einen natürlichen Swimmingpool, der direkt ins Meer gebaut wurde. Hier können Sie sorgenfrei und entspannt im ruhigen Seewasser verweilen und eine sichere, entspannte Zeit genießen.
                        </p>
                    </div>
                </div>

                <div className="mx-auto mt-14 grid max-w-7xl gap-7 md:grid-cols-2 lg:mt-20 lg:gap-9">
                    {aadyaHighlights.map((highlight) => <article key={highlight.title} className="overflow-hidden rounded-[24px] bg-[#fbfaf7] shadow-[0_20px_60px_rgba(16,38,26,0.08)]">
                            <div className="relative h-72 bg-[#f3eee7] sm:h-80">
                                <img src={highlight.image} alt={highlight.title} className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
                                <h3 className="absolute inset-x-5 bottom-5 font-serif text-2xl font-semibold leading-tight text-white sm:text-3xl">
                                    {highlight.title}
                                </h3>
                            </div>
                            <div className="p-6 sm:p-7">
                                <div className="space-y-4 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                                    {highlight.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                                </div>
                                {highlight.features ? <ul className="mt-5 space-y-3 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                                        {highlight.features.map((feature) => <li key={feature}>{feature}</li>)}
                                    </ul> : null}
                                {highlight.links ? <div className="mt-6 flex flex-wrap gap-3">
                                        {highlight.links.map((link) => <Link key={link.label} to={link.href} className="inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]">
                                                » {link.label}
                                            </Link>)}
                                    </div> : null}
                            </div>
                        </article>)}
                </div>
            </div>
        </section>;
};
export default AboutAadya;
